export default __webpack_public_path__ + "static/media/pngIcon.eed7586c.svg";